import { datafluxRum } from '@cloudcare/browser-rum';
datafluxRum.onReady(function () {
    try {
        var userData = localStorage.getItem('library_userInfo')
        userData = userData ? JSON.parse(userData) : {}
        if (userData && userData.userId) {
            datafluxRum.setGlobalContextProperty('userId', userData.userId);
        }
    } catch (error) {

    }
})
datafluxRum.init({
    applicationId: 'knowledge_base',
    datakitOrigin: '/datakit', // 协议（包括：//），域名（或IP地址）[和端口号],
    env: process.env.NODE_ENV,
    version: '1.0.0',
    service: 'knowledge_base',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    compressIntakeRequests: true,
    trackInteractions: true,
    traceType: 'w3c_traceparent', // 非必填，默认为ddtrace，目前支持 ddtrace、zipkin、skywalking_v3、jaeger、zipkin_single_header、w3c_traceparent 6种类型
    allowedTracingOrigins: [/https:\/\/knowledgebase.*\.sangfor\.com/,  /https:\/\/knowledgebase-eu.*\.sangfor\.com/,],  // 非必填，允许注入trace采集器所需header头部的所有请求列表。可以是请求的origin，也可以是是正则
});
datafluxRum.startSessionReplayRecording()

